import { deepExtract } from 'helpers/deep';

export const filterSetFilters = (state, filterSet) => deepExtract(`filterSets.${filterSet}.filters`, state, false);
export const filterSetFilterValue = (state, filterSet, filter) =>
  deepExtract(`filterSets.${filterSet}.filters.${filter}.value`, state, undefined);
export const filterSetIsFiltered = (state, filterSet) => deepExtract(`filterSets.${filterSet}.filtered`, state, false);
